// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M2 11C2 10.4477 2.44772 10 3 10H21C21.5523 10 22 10.4477 22 11V13C22 13.5523 21.5523 14 21 14H3C2.44772 14 2 13.5523 2 13V11Z\" fill=\"black\"/> </svg> ";
// Exports
module.exports = code;